<template>
    <nav class="drawer-tabs">
        <ul class="drawer-tabs__list">
            <li
                v-for="(tab, index) in tabs"
                :key="index"
                class="drawer-tabs__item"
            >
                <button
                    class="drawer-tabs__link"
                    :class="{ [STATE_CLASSES.SELECTED]: activeTab === tab }"
                    @click.stop="selected(tab)"
                >
                    {{ tab }}
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    name: 'drawer-tabs',

    props: {
        tabs: {
            type: Array,
            default: () => ([]),
        },

        activeTab: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            STATE_CLASSES,
        };
    },

    methods: {
        selected(tab) {
            this.$emit('selected', tab);
        },
    },
};
</script>

<style lang="scss">
.drawer-tabs {
    align-items: center;
    width: 100%;
    margin-top: 12px;

    &__list {
        margin: 0;
        padding: 0;
        display: flex;
    }

    &__item {
        display: flex;
        list-style: none;
    }

    &__link {
        color: var(--modal-headerColor);
        position: relative;
        text-decoration: none;
        font-size: 1rem;
        padding: 0.5rem 1rem;
        min-width: 8rem;

        &:hover {
            cursor: pointer;
            color: var(--modal-headerColor);
            text-decoration: none !important;
        }

        &:before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 3px;
            background-color: var(--modal-headerColor);
            transition: transform 0.45s;
            transform: scaleX(0);
        }

        &.#{ $is-selected }:before {
            transform: scaleX(1);
        }
    }
}
</style>
